import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { styled } from '@storybook/theming';
import { graphql } from 'gatsby';
import { styles } from '@storybook/design-system';
import { Post } from '../components/Post/Post';
import { MetaData } from '../components/MetaData';
import { Layout } from '../components/Layout';

const MarginWrapper = styled.div`
  ${styles.pageMargins}
`;

const WhatsNewPostPage = ({ data, pageContext, location }) => {
  const post = data.ghostPost;
  const settings = data.allGhostSettings.edges[0].node;

  return (
    <Layout minimalMode includePageMargins={false}>
      <Helmet>
        <base target="_blank" />
      </Helmet>
      <MetaData
        data={data}
        location={location}
        isPreview={pageContext.isPreview}
      />
      <MarginWrapper>
        <Post
          {...post}
          subscriberCount={data.mailingList.subscriberCount}
          ghostUrl={settings.url}
          minimalMode
        />
      </MarginWrapper>
    </Layout>
  );
};

WhatsNewPostPage.propTypes = {
  data: PropTypes.shape({
    ghostPost: PropTypes.object.isRequired,
    mailingList: PropTypes.shape({
      subscriberCount: PropTypes.number,
    }).isRequired,
    allGhostSettings: PropTypes.object.isRequired,
  }).isRequired,
  pageContext: PropTypes.object.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export const query = graphql`
  query WhatsNewPostPageQuery($slug: String!) {
    ghostPost(slug: { eq: $slug }) {
      ...GhostPostFields
    }
    mailingList {
      subscriberCount
    }
    allGhostSettings {
      edges {
        node {
          url
        }
      }
    }
  }
`;

export default WhatsNewPostPage;
